<template>
  <div id="mask">

  <div class="voucher-count">
    <!-- @close="VoucherClose" -->
    <el-dialog class="self-demo-dialog" center     :visible.sync="answerShow"        @close="close"  append-to-body>
     <div class="textarea-box">
      <textarea 
        v-model="content"
        @input="adjustHeight"
        ref="textarea"
         placeholder="请输入你想查询的物品或功能"
        class="answer-textarea"
      ></textarea>
      <div class="submit" >
        <div class="submit-button" @click="submit()">查询</div>
      </div>
      <div class="answer-title">注：请输入你想查询的物品或功能，测试版本功能，正在陆续完善</div>
    </div>
      <div class="answer-content" v-for="(answer, index) in answerList" :key="answer.id || index">
        <div class="answer-info" >
         <div class="answer-order">{{ index + 1 }}. {{ answer.answers }}</div>
          <div class="answer-img" v-if="answer.img && answer.img.length > 0" >
            <!-- 这里应该是显示图片而不是重复显示 answers -->
            <img :src="answer.img"    @click="showPreview(answer.img, $event)"  >
          </div>
        </div>
  
      </div>

           <!-- 图片预览层 -->
           <div class="image-preview-overlay" v-if="previewVisible" @click.self="hidePreview">
          <div class="image-preview-container" >
            <img :src="previewImage" class="preview-image">
            <i class="el-icon-close close-icon" @click="hidePreview"></i>
          </div>
        </div>

    </el-dialog>

  

 </div>
   


</div>
</template>

<script>
import { Notification } from "element-ui";
import orderApi from "../../../api/orderApi";



export default {
  // props: {
    name: 'UserInfoForm',
  // },
  data() {




    return {
      answerShow:false,
      codeShow:0,
      content: '',
      answerList:[],
        // 其他数据保持不变...
      previewVisible: false,
      previewImage: '',
      // previewStyle: {
      //   top: '0',
      //   left: '0'
      // }
    };
    
  },

  computed: {
 

  },
  mounted() {
 
    // this.getCode();
    this.adjustHeight(); // 初始化时调整高度
  
  },
 
  methods: {
    adjustHeight() {
      const textarea = this.$refs.textarea;
      if (!textarea) return; // 避免 undefined 报错
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
    },
    //关闭弹框
    close() {

      this.$emit("update:answerClose", false);
      this.content='';
      this.answerList='';
    },
   async submit(){
    if (!this.content.trim()) {
      this.$message({
          type: 'error',
          message: "输入问题不能为空"
        })
       return;
      }
     let content=  this.content.replace(/\s+/g, '')
     let params = { answers: content};

          const res = await orderApi.getAnswers(params);
          if (res.result == 1) {
            this.answerList=res.data;
           
          } 
   },
 
      // 显示预览
      showPreview(imgUrl, event) {
      this.previewImage = imgUrl;
      this.previewVisible = true;
      
      // 计算位置，使预览层出现在点击图片的上方
      const imgElement = event.target;
      const rect = imgElement.getBoundingClientRect();
      
      this.previewStyle = {
        top: `${rect.top - 200}px`, // 200是预览层高度，根据需要调整
        left: `${rect.left}px`
      };
    },
    
    // 隐藏预览
    hidePreview() {
      this.previewVisible = false;
    },

     // 一键复制
     async copy(content) {
      try {
        let res = await this.$utils.doCopy(content);
        Notification({
          title: res,
          offset: 50,
          customClass: "messageIndex",
          type: "success",
        });

        setTimeout(() => {
          this.dialogShow = false;
        }, 1000);
      } catch (error) {
        Notification({
          message: error,
          offset: 50,
          customClass: "messageIndex",
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>


.voucher-count{
  width: 100%;
  // justify-content: center;
  // align-items: center;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  ::v-deep .el-dialog--center{
     border: 1px solid;
     border-radius: 2%;
    }

}
//充值选择表单区域

.self-demo-dialog {

  position: fixed;


  ::v-deep .el-form-item__label {
    position: relative;
  }
  ::v-deep .el-dialog {
    width:350px;
    height:auto;
    // background-image: url('../../../assets/image/pc/order/anchor.png');
    // background-size: 100% 100%;
    // background-color: transparent;
    // border-radius: 3%;
    -webkit-box-shadow: 0 1px 3px transparent;
    box-shadow: 0 1px 3px transparent;
    background-color: #f4f4f4;
    }
    ::v-deep .el-dialog_body{
      padding: 15px auto !important;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    // background-color: hsl(0, 99%, 0%);
  

    }
    ::v-deep .el-dialog__header {
      padding: 0px 10px 10px;
      
    }

  ::v-deep .el-form-item__label:before {
    display: inline-block;
    position: relative;
    top: 3px;
    left: -2px;;
    content: '' !important;
    width: 14px;
    height: 16px;
    background: url(../../../assets/image/pc/recharge/lx.png) no-repeat !important;
    background-size: 14px 16px !important;
  }
  ::v-deep  .el-form {
      // min-width: 400px;
      }
  ::v-deep  .el-form-item__label {
        width: 100%;
        font-size: 16px;
        font-weight: 600;
        color: #502d07;
  }
  
  ::v-deep  .el-input--suffix {
        width: 300px;

  }
  // .el-select-dropdown{
  //   width: 100%;
  //       font-size: 16px;
  //       font-weight: 600;
  //       color: #502d07;
  // }
   
    ::v-deep  .el-input__inner {
        // height: 40px;
        // color: #000000;
        font-size: 16px;
      }  
    ::v-deep  .el-select-dropdown__list span {
      font-size: 16px;
    }
  
  // ::v-deep  .el-input {
  //       width: 100%;
  //       height: 40px;
  //       background-color: #fbf8f1;
  //       border-radius: 8px;
  //     }

}


//调整弹框的
    ::v-deep .el-dialog__body {
      padding: 15px auto !important;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
    }
    ::v-deep .el-dialog__headerbtn .el-dialog__close{
      font-size: 10px;
       line-height: 1px;
       margin-right: -6px;
       color: #9a9797;
      

    }
    .textarea-box{
      width: 100%;
      border: 1px solid #9a9797;
      margin-bottom: 4%;
      border-radius: 3px;
      background-color: #fff;
      .answer-textarea{
        width:100%;
        font-size:15px;
        overflow:hidden;
         resize:none;
         text-indent: 1em;
   
         padding:0px;
         padding-top: 5px; 
         border: none;
         border-radius: 3px;
       
      }
        .answer-textarea::placeholder {
        color: #999; /* 灰色提示文字 */
        font-style: italic; /* 可选：斜体显示 */
        font-size:12px;
     
      }

      .submit{
        width:100px;
        height: 40px;
        margin-left:78%;
        margin-bottom: 1%;
        .submit-button{
          width:55px;
          height: 30px;
          background-color: #409eff;
          border-radius: 3px;
          color:#fff;
          text-indent: 1em;
          line-height: 30px;

        }
      }
       .answer-title{
        width:96%;
        text-align: right;
        color: red;
        font-size: 8px;
        margin-bottom: 1%;
       }
 
    }
   
  
      .answer-content{
        width: 100%;
        border-radius:3px;
        border: 1px solid #ccc;
        background-color: #fff;
        margin-bottom: 2%;
        .answer-order{
          width: 90%;
          margin-left:5%;
          margin-top: 4px;
          font-size:12px;
          margin-bottom: 2%;
          // border-bottom:1px solid #ccc;
        }
        .answer-img{
          width: 25%;
          height:30px;
          margin-left: 70%;

          // border-bottom:1px solid #ccc;
          img{
            width: 100%;
            height: 30px;
    
          }
        }
      }
 
      /* 图片预览层样式 */
      .image-preview-overlay {
        position: fixed;
        top: 0;
        left: 0px;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 2000;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .image-preview-container {
        position: absolute;
        background: white;
        padding: 10px;
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        max-width: 80%;
        max-height: 80%;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .preview-image {
        max-width: 100%;
        max-height: 400px; /* 限制最大高度 */
        object-fit: contain;
      }

      .close-icon {
        position: absolute;
        top: 5px;
        right: 5px;
        cursor: pointer;
        font-size: 20px;
        color: #999;
        
        &:hover {
          color: #333;
        }
      }

      /* 调整原图片样式 */
      .answer-img {
        width: 100px; /* 调整为合适的尺寸 */
        height: 100px;
        margin: 5px auto;
        cursor: pointer;
        
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }





</style>
